// Actions (must be name-spaced for reducer)

export const SIDE_NAV_EXPAND = "SIDE_NAV_EXPAND";
export const SIDE_NAV_COLLAPSE = "SIDE_NAV_COLLAPSE";

// Reducer

export function sideNavReducer(state = {}, action = {}) {
    switch (action.type) {
        case SIDE_NAV_EXPAND:
            return {
                mobileSideNavExpanded: true
            };
        case SIDE_NAV_COLLAPSE:
            return {
                mobileSideNavExpanded: false
            };
        default:
            return state;
    }
}

// Action Creators

export function expandMobileSideNav() {
    return {
        type: SIDE_NAV_EXPAND
    };
}

export function collapseMobileSideNav() {
    return {
        type: SIDE_NAV_COLLAPSE
    };
}

export default {
    sideNavReducer,
    expandMobileSideNav,
    collapseMobileSideNav
};
